module.exports = __webpack_public_path__ + "img/etcd.457cba13.svg";